export const isPublicAuthPath = (pathname: string) =>
	pathname.includes("restore/") ||
	pathname === "/reset-password" ||
	pathname === "/signup" ||
	pathname === "/confirm-email" ||
	pathname.startsWith("/kyc/") ||
	pathname === "/invite" ||
	pathname.startsWith("/invite/")
